module.exports = __webpack_public_path__ + "img/fullscreen_exit.ea8cc88c.svg";